module.exports = __webpack_public_path__ + "img/question_answer.e37ae67b.svg";